module.exports = __webpack_public_path__ + "img/mpb.806dbbe6.png";